/* Установщик «Сменить голос»: объект в window на том месте порядка скриптов, где стоял assets/bot-voice.js.
   В серверном режиме движок шаблона получает сервер экрана (voice-server.ts) и экран voice встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createVoice } from './engine';
import { createVoiceServer, registerVoiceEngine } from './voice-server';

export function installVoice() {
  const server = isServerMode();
  createVoice(server ? createVoiceServer : null);
  if (server) registerVoiceEngine();
}
